import { AbstractControl, ValidationErrors } from '@angular/forms';

export const emailValidator = (control: AbstractControl): ValidationErrors | null => {
	return !control.value || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(control.value)
		? null
		: { email: true };
};

export const nationalInsuranceNumberValidator = (control: AbstractControl): ValidationErrors | null => {
	return !control.value ||
		/^[A-CEGHJ-PR-TW-Z]{1}[A-CEGHJ-NPR-TW-Z]{1}[0-9]{6}[A-D\s]{0,1}$/.test(control.value.toUpperCase())
		? null
		: { nationalInsuranceNumber: true };
};
